import { css, DefaultTheme } from 'styled-components';

import { ExtendedPartialThemedStyledProps } from './types';

export type FontScaleName = keyof DefaultTheme['fontScales'];

export type FontScaleProps = {
  scale?: FontScaleName;
};

export type ThemeAndFontScaleProps = ExtendedPartialThemedStyledProps<FontScaleProps>;

const getFontScale = ({ theme, scale }: ThemeAndFontScaleProps) => {
  const isValid = scale && theme?.fontScales[scale];

  return isValid
    ? css`
        font-size: ${theme.fontScales[scale][0]};
        line-height: ${theme.fontScales[scale][1]};
      `
    : null;
};

export { getFontScale };
